import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgYouTubeIcon from './svgs/YouTubeIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var youTubeIcon = (props => useIcon(SvgYouTubeIcon, SvgYouTubeIcon, props));

export { youTubeIcon as default };
